<template>
    <div class="center">
        <div class="main">
            <div>
                <on></on>
                <Row>
                    <Col span="24" class="body">
                        <router-view :key="key"></router-view>
                    </Col>
                </Row>
                <up></up>
            </div>
        </div>
    </div>
</template>

<script>
    import header from './on'
    import footer from './up'

    export default {
        name: 'Admin',
        components: {
            on: header,
            up: footer,
        },
        data() {
            return {
                key: 1
            }
        },
        watch: {
            $route(to, from) {
                this.key += 1
                // console.log(this.key)
                // console.log(to.path)
            }
        },
    }
</script>

<style lang="scss">
    .center {
        text-align: center;

        .main {
            width: 1200px;
            display: inline-block;

            .body{
                margin-bottom: 55px;
            }
        }
    }
</style>
